import config from './Rest';

import {
  getFileNameWithoutExtension
} from './../Utility/utility';

export function getFilters(context, currentfilters, isfreshCall) {
  let params = {
    provider: context.providerList,
    dealType: context.selectedPackageType
  };

  return config
    .getFilters(params)
    .then((res) => {
      if (res.data.result) {
        let downloadSpeedObj = res.data.result['downloadSpeed'].map((item) => {
          const existingItem = currentfilters
            ? currentfilters.downloadSpeed.find((e) => e.value === item)
            : null;

          return {
            value: item,
            selected: isfreshCall ? false : existingItem ? existingItem.selected : false
          };
        });
        context.setFilters({
          downloadSpeed: downloadSpeedObj,
          onPromotion: res.data.result.onPromotion[0]
        });
      }
    })
    .catch((error) => {
      console.error('Failed to get filters: \n', error);
    });
}

export function getProviderPackages(
  providerList,
  sortOrder,
  pageOffset,
  filterList,
  sortBy,
  dealType
) {
  return config
    .getProviderPackages(
      providerList,
      sortOrder,
      pageOffset,
      filterList,
      sortBy,
      dealType
    )
    .then((res) => {
      if (
        res.data &&
        res.data.result &&
        res.data.result.products.length > 0
      ) {
        return Promise.resolve(res.data.result.products);
      } else {
        return Promise.reject(res);
      }
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}

export function getRecommendedOffers() {
  return config
    .getRecommendedOffers()
    .then((res) => {
      if (res.data.result) {
        return Promise.resolve(res.data.result);
      }
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}

export function getPackageSuggestions(latitude, longitude, internetUsage, peopleConnected, onlyRecommended) {
  return config
    .getPackageSuggestions(latitude, longitude, internetUsage, peopleConnected, onlyRecommended)
    .then((res) => {

      if (res.data) {
        return Promise.resolve(res.data);
      }
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}

export function getLineSpeeds(latitude, longitude, contractTerm) {
  return config
    .getLineSpeeds(latitude, longitude, contractTerm)
    .then((res) => {
      if (res.data) {
        return Promise.resolve(res.data);
      }
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}

export function getRecommendations(internetUsage, peopleConnected) {
  return config
    .getHelpMeChoosePlanSpeeds(internetUsage, peopleConnected)
    .then((res) => {
      if (res.data) {
        return Promise.resolve(res.data);
      }
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}

export function getOffers(latitude, longitude, uploadSpeed, downloadSpeed) {
  return config
    .getOffers(latitude, longitude, uploadSpeed, downloadSpeed)
    .then((res) => {
      if (res.data) {
        return Promise.resolve(res.data);
      }
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}

export function getAdditionalServices() {
  return config
    .getAdditionalServices()
    .then((res) => {
      if (res.data) {
        return Promise.resolve(res.data.result);
      }
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}

export function submitLead(context) {

  const agentUsername = sessionStorage.getItem('retailUserDetails') ? JSON.parse(sessionStorage.getItem('retailUserDetails')).username : null;

  let payload = {
    leadType: '',
    contactWorkPhoneNumber: (
      context.userDetails.contactNumber ?
        context.userDetails.contactNumber.trim() : context.vettingCreditDetails?.contactDetails?.cellPhoneNo?.value.trim()
    ),
    contactFirstName: (
      context.userDetails.firstName ?
        context.userDetails.firstName.trim() : context.vettingCreditDetails?.personalDetails?.firstName?.value.trim()
    ),
    contactMobilePhoneNumber: (
      context.userDetails.contactNumber ?
        context.userDetails.contactNumber.trim() : context.vettingCreditDetails?.contactDetails?.cellPhoneNo?.value.trim()
    ),
    contactLastName: (
      context.userDetails.lastName ?
        context.userDetails.lastName.trim() : context.vettingCreditDetails?.personalDetails?.surname?.value.trim()
    ),
    secondaryEmailAddress: context.vettingCreditDetails.contactDetails?.secondaryEmail?.value?.trim(),
    productId: context.selectedPackage.offeringID,
    channel: context.selectedPackage.status,
    contactEmailAddress: (
      context.userDetails.email ?
        context.userDetails.email.trim() : context.vettingCreditDetails?.contactDetails?.email?.value.trim()
    ),
    productSelected: `${ context.selectedPackage.provider } - ${ context.selectedPackage.description }`,
    identityNumber:
      context.employmentDetails.selectedIdTab === 'idNumber'
        ? context.employmentDetails.idNumber &&
        context.employmentDetails.idNumber.trim()
        : context.employmentDetails.passportNumber &&
        context.employmentDetails.passportNumber.trim(),
    installationAddress: { ...context.installationAddress },
    deliveryAddress: null,
    fromCampaign: false,
    additionalServices: { ...context.selectedAdditionalServices }
  };

  payload.installationAddress.streetAddress =
    context.installationAddress?.streetName;
  payload.installationAddress.streetNumber =
    context.installationAddress?.streetNumber;
  payload.installationAddress.formattedAddress =
    (`${ context.installationAddress?.unitNumber ? context.installationAddress?.unitNumber.trim() + ', ' : '' } ${ context.installationAddress?.buildingName ? context.installationAddress?.buildingName.trim() + ', ' : '' } ${ context.installationAddress?.formattedAddress.trim() }`).trim();

  if (context.deliveryAddressType?.toUpperCase() === 'To another address'.toUpperCase()) {
    payload.deliveryAddress = context.deliveryAddress;
    payload.deliveryAddress['latitude'] = '';
    payload.deliveryAddress['longitude'] = '';
    payload.deliveryAddress['docid'] = '';
    payload.deliveryAddress['formattedAddress'] =
      (context.deliveryAddress.unitNumber.trim() || '') +
      ', ' + (context.deliveryAddress.buildingName.trim() || '') +
      (context.deliveryAddress.streetAddress.trim() ? `, ${ context.deliveryAddress.streetAddress.trim() }` : '') +
      (context.deliveryAddress.suburb.trim() ? `, ${ context.deliveryAddress.suburb.trim() }` : '') +
      (context.deliveryAddress.city.trim() ? `, ${ context.deliveryAddress.city.trim() }` : '') +
      (context.deliveryAddress.province.trim() ? `, ${ context.deliveryAddress.province.trim() }` : '') +
      (context.deliveryAddress.postalCode.trim() ? `, ${ context.deliveryAddress.postalCode.trim() }` : '');
  } else {
    payload.deliveryAddress = {
      unitNumber: context.installationAddress?.unitNumber,
      buildingName: context.installationAddress?.buildingName,
      streetNumber: context.installationAddress?.streetNumber,
      streetAddress: context.installationAddress?.streetName,
      suburb: context.installationAddress?.suburb,
      city: context.installationAddress?.city,
      province: context.installationAddress?.province,
      postalCode: context.installationAddress?.postalCode,
      latitude: context.installationAddress?.latitude
        ? context.installationAddress?.latitude
        : '',
      longitude: context.installationAddress?.longitude
        ? context.installationAddress?.longitude
        : '',
      docid: context.installationAddress?.docid
        ? context.installationAddress?.docid
        : '',
      seoid: context.installationAddress?.seoid,
      formattedAddress: (`${ context.installationAddress?.unitNumber ? context.installationAddress?.unitNumber.trim() + ',' : '' } ${ context.installationAddress?.buildingName ? context.installationAddress?.buildingName.trim() + ',' : '' } ${ context.installationAddress?.formattedAddress.trim() }`).trim()
    };
  }

  payload['dealType'] = context.selectedPackageType;
  payload['customerType'] = context.isUserExisting ? 'existingIndividual' : 'newIndividual';
  let params = {
    vettingType: context.isUserExisting ? 'existingIndividual' : 'newIndividual'
  };
  payload.alternativeContactDetails = {
    alternativeContactFirstName: context.vettingCreditDetails?.contactDetails?.altContactPerson?.value?.trim(),
    alternativeContactMobilePhoneNumber: context.vettingCreditDetails?.contactDetails?.altCellPhoneNo?.value?.trim()
  };

  if (agentUsername) {

    payload.agent = {
      username: agentUsername
    };
  }

  return config
    .submitLead(payload, params)
    .then((res) => {
      if (res.data) {
        return Promise.resolve(res.data);
      } else {
        return Promise.reject(res);
      }
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}

export function getContractTerm(data, _url) {
  let payload = {
    dataType: data.dataType,
    downloadSpeed: data.downloadSpeed,
    uploadSpeed: data.uploadSpeed,
    dataCap: data.dataCap ? data.dataCap : '',
    price: data.price,
    provider: data.provider
  };

  return config
    .getContractTerm(payload)
    .then((res) => Promise.resolve(res.data))
    .catch((error) => Promise.reject(error));
}

export function checkIsExistingUser(context) {
  let role = context.employmentDetails.selectedIdTab === 'idNumber' ? 'ID Number' : 'Passport';

  let id =
    context.employmentDetails.selectedIdTab === 'idNumber'
      ? context.employmentDetails.idNumber.trim()
      : context.employmentDetails.passportNumber.trim();

  return config
    .isExistingUser(role, id)
    .then((res) => Promise.resolve(res.data))
    .catch((error) => Promise.reject(error.response));
}

export function checkIsValidOTP(otpValue, context) {

  let role = context.employmentDetails.selectedIdTab === 'idNumber' ? 'ID Number' : 'Passport';

  let id = context.employmentDetails.selectedIdTab === 'idNumber'
    ? context.employmentDetails.idNumber.trim()
    : context.employmentDetails.passportNumber.trim();

  return config
    .checkValidOTP(otpValue, id, role)
    .then((res) => Promise.resolve(res.data))
    .catch((error) => Promise.reject(error.response));
}

// Get Called for existing customer
export function submitSalesOrder(context, username, otp) {

  const payload = {
    contactDetails: {
      contactFirstName:
        context.userDetails.firstName && context.userDetails.firstName.trim(),
      contactMobilePhoneNumber:
        context.userDetails.contactNumber &&
        context.userDetails.contactNumber.trim(),
      contactLastName:
        context.userDetails.lastName && context.userDetails.lastName.trim(),
      contactEmailAddress:
        context.userDetails.email && context.userDetails.email.trim()
    },
    billingAccountNumber: context.userDetails?.billingAccountNumber ?? '',
    productId: context.selectedPackage.offeringID,
    channel: context.selectedPackage.status,
    plan: context.selectedPackage.dataCap,
    speed: `${ parseInt(context.selectedPackage.download) }/${ parseInt(
      context.selectedPackage.upload
    ) } Mbps`,
    planType: context.selectedPackage.dataCap,
    price: `R${ parseInt(context.selectedPackage.productPrice.value) } PM x ${ context.selectedContractTerm
    }`,
    serviceProvider: context.selectedPackage.provider,
    inclusions: context.selectedPackage.inclusions,
    productSelected: `${ context.selectedPackage.provider } - ${ context.selectedPackage.description }`,
    contractTerm: context.selectedContractTerm,
    identityNumber:
      context.employmentDetails.selectedIdTab === 'idNumber'
        ? context.employmentDetails.idNumber &&
        context.employmentDetails.idNumber.trim()
        : context.employmentDetails.passportNumber &&
        context.employmentDetails.passportNumber.trim(),
    identityNumberType:
      context.employmentDetails.selectedIdTab === 'idNumber'
        ? 'SAID'
        : 'Passport Number',
    additionalServices: { ...context.selectedAdditionalServices },
    installationAddress: { ...context.installationAddress },
    deliveryAddress: null,
    employmentDetails: {
      employmentType: context.employmentDetails.employmentType,
      employerName: context.employmentDetails.employerName
    }
  };

  if (username && otp) {

    payload.agent = {
      username: username,
      customerOtp: otp
    };
  }

  payload.installationAddress.streetAddress =
    context.installationAddress?.streetAddress;
  payload.installationAddress.streetNumber =
    context.installationAddress?.streetNumber;
  payload.installationAddress.formattedAddress =
    (`${ context.installationAddress?.unitNumber ? context.installationAddress?.unitNumber.trim() + ',' : '' } ${ context.installationAddress?.buildingName ? context.installationAddress?.buildingName.trim() + ',' : '' } ${ context.installationAddress?.formattedAddress.trim() }`).trim();

  if (context.selectedPackage.dataCap.toLowerCase() === 'capped') {
    payload.productSelected = `${ context.selectedPackage.provider } - ${ context.selectedPackage.dataCap } ${ context.selectedPackage.dataType }`;
  } else {
    payload.productSelected = `${ context.selectedPackage.provider } - ${ context.selectedPackage.description }`;
  }

  if (context.deliveryAddressType?.toUpperCase() === 'To another address'.toUpperCase()) {
    payload.deliveryAddress = context.deliveryAddress;
    payload.deliveryAddress['latitude'] = '';
    payload.deliveryAddress['longitude'] = '';
    payload.deliveryAddress['docid'] = '';
    payload.deliveryAddress['formattedAddress'] =
      (context.deliveryAddress.unitNumber.trim() || '') +
      ', ' + (context.deliveryAddress.buildingName.trim() || '') +
      (context.deliveryAddress.streetAddress.trim() ? `, ${ context.deliveryAddress.streetAddress.trim() }` : '') +
      (context.deliveryAddress.suburb.trim() ? `, ${ context.deliveryAddress.suburb.trim() }` : '') +
      (context.deliveryAddress.city.trim() ? `, ${ context.deliveryAddress.city.trim() }` : '') +
      (context.deliveryAddress.province.trim() ? `, ${ context.deliveryAddress.province.trim() }` : '') +
      (context.deliveryAddress.postalCode.trim() ? `, ${ context.deliveryAddress.postalCode.trim() }` : '');
  } else {
    payload.deliveryAddress = {
      unitNumber: context.installationAddress?.unitNumber,
      buildingName: context.installationAddress?.buildingName,
      streetNumber: context.installationAddress?.streetNumber,
      streetAddress: context.installationAddress?.streetName,
      suburb: context.installationAddress?.suburb,
      city: context.installationAddress?.city,
      province: context.installationAddress?.province,
      postalCode: context.installationAddress?.postalCode,
      latitude: context.installationAddress?.latitude
        ? context.installationAddress?.latitude
        : '',
      longitude: context.installationAddress?.longitude
        ? context.installationAddress?.longitude
        : '',
      docid: context.installationAddress?.docid
        ? context.installationAddress?.docid
        : '',
      seoid: context.installationAddress?.seoid,
      formattedAddress: (`${ context.installationAddress?.unitNumber ? context.installationAddress?.unitNumber.trim() + ',' : '' } ${ context.installationAddress?.buildingName ? context.installationAddress?.buildingName.trim() + ',' : '' } ${ context.installationAddress?.formattedAddress.trim() }`).trim()
    };
  }

  if (context.additionalVas) {
    payload['additionalVas'] = context.additionalVas;
  } else {
    payload['additionalVas'] = [];
  }

  payload['dealType'] = context.selectedPackageType;
  payload['isExistingCustomer'] = context.isUserExisting;
  payload['vettingType'] = context.isUserExisting ? 'existingIndividual' : 'newIndividual';

  payload['debiCheckFlag'] = context.debiCheckSelected ? 'Y' : 'N';
  payload['superWifiDiscount'] = context?.additionalVas?.discount ? context?.additionalVas?.discount : '';

  return config
    .submitOrder(payload, context.selectedPackage.offeringID)
    .then((res) => {
      return res.data ? Promise.resolve(res.data) : Promise.reject(res);
    })
    .catch((error) => Promise.reject(error));
}

export function getProvinceList() {
  return config
    .getProvince()
    .then((res) => Promise.resolve(res.data))
    .catch((error) => Promise.reject(error));
}

export function getSalesOrderDetais(sonumber) {
  return config
    .getSalesOrderStatus(sonumber)
    .then((res) => Promise.resolve(res.data))
    .catch((error) => Promise.reject(error.response));
}

export function getVumareachLocationDetails(latitude, longitude) {

  return config
    .getVumareachLocationDetails(latitude, longitude)
    .then((res) => {
      if (res.data && res.data.result && res.data.result.place && res.data.result.place.length > 0) {
        return Promise.resolve(res.data);
      } else {
        return Promise.reject(res);
      }
    })
    .catch((error) => Promise.reject(error));
}

export function getVumareachOfferDetails(packageDetails) {

  return config
    .getVumareachOfferDetails(packageDetails)
    .then((res) => {
      if (res.data && res.data.result && res.data.result.offerDetails) {
        return Promise.resolve(res.data.result.offerDetails);
      } else {
        return Promise.reject(res);
      }
    })
    .catch((error) => Promise.reject(error));
}

export function submitVumareachOrder(context, username, otp) {
  const payload = {
    contactDetails: {
      contactMobilePhoneNumber: context.vumaContactDetails.cellPhone && context.vumaContactDetails.cellPhone.trim(),
      contactEmailAddress: context.vumaContactDetails.email && context.vumaContactDetails.email.trim(),
      additionalNumber: context.vumaContactDetails.cellPhone && context.vumaContactDetails.cellPhone.trim(),
      contactFirstName: context.vumaContactDetails.firstName && context.vumaContactDetails.firstName.trim(),
      contactLastName: context.vumaContactDetails.lastName && context.vumaContactDetails.lastName.trim()
    },
    contactWorkPhoneNumber:
      context.vumaContactDetails.cellPhone &&
      context.vumaContactDetails.cellPhone.trim(),
    productId: context.vumaSelectedProductID,
    channel: context.selectedPackage.status,
    contactEmailAddress:
      context.vumaContactDetails.email &&
      context.vumaContactDetails.email.trim(),
    plan: context.selectedPackage.dataCap,
    speed: `${ parseInt(context.selectedPackage.download) }/${ parseInt(
      context.selectedPackage.upload
    ) } Mbps`,
    planType: context.selectedPackage.dataCap,
    price: context.selectedPackage.productPrice.value,
    serviceProvider: context.selectedPackage.provider,
    inclusions: context.selectedVumaContractTerms.inclusions,
    productSelected: `${ context.selectedPackage.provider } - ${ context.selectedPackage.description }`,
    contractTerm: context.selectedVumaContractTerms.duration,
    installationAddress: {
      buildingName: context.installationAddress?.buildingName,
      city: context.installationAddress?.city,
      country: 'South Africa',
      latitude: context.installationAddress?.latitude
        ? context.installationAddress?.latitude
        : '',
      longitude: context.installationAddress?.longitude
        ? context.installationAddress?.longitude
        : '',
      docid: context.installationAddress?.docid
        ? context.installationAddress?.docid
        : '',
      seoid: context.installationAddress?.seoid,
      postalCode: context.installationAddress?.postalCode,
      province: context.installationAddress?.province,
      streetAddress: context.installationAddress?.streetName,
      streetNumber: context.installationAddress?.streetNumber,
      suburb: context.installationAddress?.suburb,
      unitNumber: context.installationAddress?.unitNumber,
      formattedAddress: (`${ context.installationAddress?.unitNumber ? context.installationAddress?.unitNumber.trim() + ',' : '' } ${ context.installationAddress?.buildingName ? context.installationAddress?.buildingName.trim() + ',' : '' } ${ context.installationAddress?.formattedAddress.trim() }`).trim()
    },
    deliveryAddress: {
      unitNumber: context.installationAddress?.unitNumber,
      buildingName: context.installationAddress?.buildingName,
      streetNumber: context.installationAddress?.streetNumber,
      streetAddress: context.installationAddress?.streetName,
      suburb: context.installationAddress?.suburb,
      city: context.installationAddress?.city,
      province: context.installationAddress?.province,
      postalCode: context.installationAddress?.postalCode,
      latitude: context.installationAddress?.latitude
        ? context.installationAddress?.latitude
        : '',
      longitude: context.installationAddress?.longitude
        ? context.installationAddress?.longitude
        : '',
      docid: context.installationAddress?.docid
        ? context.installationAddress?.docid
        : '',
      seoid: context.installationAddress?.seoid,
      formattedAddress: (`${ context.installationAddress?.unitNumber ? context.installationAddress?.unitNumber.trim() + ',' : '' } ${ context.installationAddress?.buildingName ? context.installationAddress?.buildingName.trim() + ',' : '' } ${ context.installationAddress?.formattedAddress.trim() }`).trim()
    },
    locationId: context.vumaInstallationAddress.id,
    locationAddress: context.vumaInstallationAddress.name,
    offerType: context.selectedVumaContractTerms.offerType
  };

  if (username && otp) {

    payload.agent = {
      username: username,
      customerOtp: otp
    };
  }

  if (context.employmentDetails.selectedIdTab === 'idNumber') {
    payload.identityNumber = context.employmentDetails.idNumber;
    payload.identityNumberType = 'SAID';
  } else {
    payload.identityNumber = context.employmentDetails.passportNumber;
    payload.identityNumberType = 'PASSPORT';
  }

  if (context.vumaProductType === 'RECURRING') {
    payload.debitOrderDay = context.selectedVumaProduct.selectedDebitOrderDate;
  } else {
    payload.numberOfVouchers = context.selectedVumaContractTerms.voucherCount;
  }

  if (context.selectedPackage.dataCap.toLowerCase() === 'capped') {
    payload.productSelected = `${ context.selectedPackage.provider } - ${ context.selectedPackage.dataCap } ${ context.selectedPackage.dataCap }`;
  } else {
    payload.productSelected = `${ context.selectedPackage.provider } - ${ context.selectedPackage.description }`;
  }

  payload['dealType'] = context.selectedPackageType;
  payload['isExistingCustomer'] = context.isUserExisting;
  payload['vettingType'] = context.isUserExisting ? 'existingIndividual' : 'newIndividual';

  payload['debiCheckFlag'] = context.debiCheckSelected ? 'Y' : 'N';
  payload['superWifiDiscount'] = context?.additionalVas?.discount ? context?.additionalVas?.discount : '';

  return config
    .submitOrder(payload, context.vumaSelectedProductID)
    .then((res) => {
      return res.data ? Promise.resolve(res.data) : Promise.reject(res);
    })
    .catch((error) => Promise.reject(error));
}

export function getAutoCompleteForAddress(searchString) {
  return config
    .getAutoCompleteForAddress(searchString)
    .then((res) => Promise.resolve(res.data))
    .catch((error) => Promise.reject(error));
}

export function getAddressObject(obj) {
  return config
    .getAddressObject(obj)
    .then((res) => Promise.resolve(res.data))
    .catch((error) => Promise.reject(error));
}

export function getBankArray() {
  return config
    .getBanksList()
    .then((response) => Promise.resolve(response.data))
    .catch((error) => Promise.reject(error));
}

export function getDropDownValuesService() {
  return config
    .getDropDownValues()
    .then((response) => Promise.resolve(response.data))
    .catch((error) => Promise.reject(error));
}

export function getDropDownValuesFromJsonService() {
  return config
    .getDropDownValuesFromJson()
    .then((response) => Promise.resolve(response.data))
    .catch((error) => Promise.reject(error));
}

export function getCountryValuesFromJsonService() {
  return config
    .getCoutriesValuesFromJson()
    .then((response) => Promise.resolve(response.data))
    .catch((error) => Promise.reject(error));
}

export function validateBankDetailsService(payload) {
  return config
    .validateBankAccount(payload)
    .then((response) => Promise.resolve(response.data))
    .catch((error) => Promise.reject(error));
}

export function getCountryList() {
  return config
    .getCountryList()
    .then((res) => Promise.resolve(res.data))
    .catch((error) => Promise.reject(error));
}

export function getBranchCodeService(bankName) {
  return config
    .getbranchCode(bankName)
    .then((res) => Promise.resolve(res?.data?.result[0] && res?.data?.result[0].branchCode))
    .catch((error) => Promise.reject(error));
}

export async function submitOrderdForNewCustomer(context, username, otp) {
  const payload = {};

  payload.additionalServices = { ...context.selectedAdditionalServices };
  payload.channel = context.selectedPackage.status;
  payload.productId = context.selectedPackage.offeringID;
  payload.plan = context.selectedPackage.dataCap;
  payload.planType = context.selectedPackage.dataCap;
  payload.fibreType = context.selectedPackage.dataCap;

  payload.price = `R${ parseInt(context.selectedPackage.productPrice.value) } PM x ${ context.selectedContractTerm }`;
  payload.serviceProvider = context.selectedPackage.provider;
  payload.installationAddress = context.installationAddress;
  payload.installationAddress.streetAddress = context.installationAddress?.streetAddress.trim() || '';
  payload.installationAddress.streetNumber = context.installationAddress?.streetNumber.trim() || '';
  payload.installationAddress.formattedAddress = (`${ context.installationAddress?.unitNumber ? context.installationAddress?.unitNumber.trim() + ',' : '' } ${ context.installationAddress?.buildingName ? context.installationAddress?.buildingName.trim() + ',' : '' } ${ context.installationAddress?.formattedAddress.trim() }`).trim();

  //deliver address
  if (context.deliveryAddressType?.toUpperCase() === 'To another address'.toUpperCase()) {
    payload.deliveryAddress = context.deliveryAddress;
    payload.deliveryAddress['latitude'] = '';
    payload.deliveryAddress['longitude'] = '';
    payload.deliveryAddress['docid'] = '';
    payload.deliveryAddress['formattedAddress'] =
      (context.deliveryAddress.unitNumber?.trim() || '') +
      ', ' + (context.deliveryAddress.buildingName?.trim() || '') +
      (context.deliveryAddress.streetAddress?.trim() ? `, ${ context.deliveryAddress.streetAddress?.trim() }` : '') +
      (context.deliveryAddress.suburb?.trim() ? `, ${ context.deliveryAddress.suburb?.trim() }` : '') +
      (context.deliveryAddress.city?.trim() ? `, ${ context.deliveryAddress.city?.trim() }` : '') +
      (context.deliveryAddress.province?.trim() ? `, ${ context.deliveryAddress.province?.trim() }` : '') +
      (context.deliveryAddress.postalCode?.trim() ? `, ${ context.deliveryAddress.postalCode?.trim() }` : '');
  } else {
    payload.deliveryAddress = {
      unitNumber: context.installationAddress?.unitNumber?.trim() || '',
      buildingName: context.installationAddress?.buildingName?.trim() || '',
      suburb: context.installationAddress?.suburb?.trim() || '',
      city: context.installationAddress?.city?.trim() || '',
      province: context.installationAddress?.province?.trim() || '',
      postalCode: context.installationAddress?.postalCode?.trim() || '',
      latitude: context.installationAddress?.latitude?.trim() || '',
      longitude: context.installationAddress?.longitude?.trim() || '',
      docid: context.installationAddress?.docid?.trim() || '',
      seoid: context.installationAddress?.seoid?.trim() || '',
      streetAddress: `${ context.installationAddress?.streetNumber?.trim() || '' } ${ context.installationAddress?.streetName?.trim() || '' }`,
      streetName: context.installationAddress?.streetName?.trim() || '',
      streetNumber: context.installationAddress?.streetNumber?.trim() || '',
      formattedAddress: context.installationAddress?.formattedAddress?.trim() || ''
    };
  }

  const homeAddress = context.vettingCreditDetails.homeAddress || {};
  const homeOwnerTypeNode = context.dropDownValues.ADDRESS_RESIDENCY_TYPE.find(item => item.name == homeAddress.ownerType?.value);

  if (
    payload.installationAddress?.streetAddress == homeAddress.streetName?.value?.trim() &&
    payload.installationAddress.streetNumber == homeAddress.streetNo?.value?.trim() &&
    payload.installationAddress.postalCode == homeAddress.postalCode?.value?.trim()
  ) {
    payload.physicalAddress.docid = payload.installationAddress?.docid;
    payload.physicalAddress.latitude = payload.installationAddress?.latitude;
    payload.physicalAddress.longitude = payload.installationAddress?.longitude;
  }

  const postalAddress = context.vettingCreditDetails.postalAddress || {};
  const postalOwnerTypeNode = context.dropDownValues.ADDRESS_RESIDENCY_TYPE.find(item => item.name == postalAddress.ownerType?.value);

  if (!context.userExistingProperties['hideVetAddress']) {
    payload.physicalAddress = {
      buildingName: homeAddress.buildingName?.value?.trim() || '',
      city: homeAddress.town?.value?.trim() || '',
      country: homeAddress.country?.value?.trim() || '',
      docid: '',
      latitude: '',
      longitude: '',
      ownerType: homeOwnerTypeNode?.value?.trim() || '',
      postalCode: homeAddress.postalCode?.value?.trim() || '',
      province: homeAddress.province?.value?.trim() || '',
      streetAddress: homeAddress.streetName?.value?.trim() || '',
      streetNumber: homeAddress.streetNo?.value?.trim() || '',
      suburb: homeAddress.suburb?.value?.trim() || '',
      unitNumber: homeAddress.unitNumber?.value?.trim() || ''
    };

    payload.postalAddress = {
      buildingName: postalAddress.buildingName?.value?.trim() || '',
      city: postalAddress.town?.value?.trim() || '',
      country: postalAddress.country?.value?.trim() || '',
      docid: '',
      latitude: '',
      longitude: '',
      ownerType: postalOwnerTypeNode?.value?.trim() || '',
      postalCode: postalAddress.postalCode?.value?.trim() || '',
      province: postalAddress.province?.value?.trim() || '',
      streetAddress: postalAddress.streetName?.value?.trim() || '',
      streetNumber: postalAddress.streetNo?.value?.trim() || '',
      suburb: postalAddress.suburb?.value?.trim() || '',
      unitNumber: postalAddress.unitNumber?.value?.trim() || ''
    };

  }

  if (username && otp) {

    payload.agent = {
      username: username,
      customerOtp: otp
    };
  }

  if (
    payload.installationAddress?.streetAddress == postalAddress.streetName?.value?.trim() &&
    payload.installationAddress.streetNumber == postalAddress.streetNo?.value?.trim() &&
    payload.installationAddress.postalCode == postalAddress.postalCode?.value?.trim()
  ) {
    payload.postalAddress.docid = payload.installationAddress?.docid;
    payload.postalAddress.latitude = payload.installationAddress?.latitude;
    payload.postalAddress.longitude = payload.installationAddress?.longitude;
  }

  payload.identityNumber =
    context.employmentDetails.selectedIdTab === 'idNumber'
      ? context.employmentDetails.idNumber &&
      context.employmentDetails.idNumber.trim()
      : context.employmentDetails.passportNumber &&
      context.employmentDetails.passportNumber.trim();

  payload.identityNumberCountry = context.employmentDetails.countryOfIssue;
  if (context.employmentDetails.selectedIdTab === 'passportNumber') {
    const dateArray = context?.employmentDetails?.dateOfExpiry?.split('/')[0].split('-');
    payload.identityNumberExpiryDate = `${ dateArray[2] }/${ dateArray[1] }/${ dateArray[0] } 00:00:00`;
  }
  payload.identityNumberType =
    context.employmentDetails.selectedIdTab === 'idNumber'
      ? 'SAID'
      : 'PASSPORT';

  if (context.selectedPackage.dataCap.toLowerCase() === 'capped') {
    payload.productSelected = `${ context.selectedPackage.provider } - ${ context.selectedPackage.dataCap } ${ context.selectedPackage.dataCap }`;
  } else {
    payload.productSelected = `${ context.selectedPackage.provider } - ${ context.selectedPackage.description }`;
  }

  payload.contractTerm = context.selectedContractTerm;

  payload.speed = `${ parseInt(
    context.selectedPackage.download
  ) }/${ parseInt(context.selectedPackage.upload) } Mbps`;

  payload.inclusions = context.selectedPackage.inclusions;

  const personalDetails = context.vettingCreditDetails.personalDetails || {};
  personalDetails.DOB.value = personalDetails.DOB.value.split('-').reverse().join('/');

  const maritalStatusNode = personalDetails.maritalStatus?.value || '';

  payload.newCustomerDetails = {
    contactDateOfBirth: `${ personalDetails.dobmm?.value?.trim() }/${ personalDetails.dobdd?.value?.trim() }/${ personalDetails.dobyyyy?.value?.trim() } 00:00:00`,
    contactGender: personalDetails.gender?.value?.trim() || '',
    contactLanguageCode: personalDetails.homeLanguage?.value?.trim() || '',
    contactMaritalStatus: maritalStatusNode?.trim() || '',
    contactTitle: personalDetails.title?.value?.trim() || ''
  };

  payload.contactDetails = {
    contactEmailAddress: context.vettingCreditDetails.contactDetails?.email?.value?.trim(),
    contactMobilePhoneNumber: context.vettingCreditDetails.contactDetails?.cellPhoneNo?.value?.trim(),
    contactFirstName: personalDetails.firstName?.value?.trim() || '',
    contactLastName: personalDetails.surname?.value?.trim() || '',
    secondaryEmailAddress: context.vettingCreditDetails.contactDetails?.secondaryEmail?.value?.trim(),
    additionalNumber: ''
  };

  const employmentDetails = context.vettingCreditDetails.workDetails || {};
  const occuptionTypeNode = context.dropDownValues.FASTTRACK_OCCUPATION_TYPE.find(item => item.name == employmentDetails.occupationType?.value);
  const employmentIndustryNode = context.dropDownValues.EMPLOYMENT_INDUSTORY.find(item => item.name == employmentDetails.employerIndustry?.value);
  const employerCategoryNode = context.dropDownValues.EMPLOYMENT_CATEGORY.find(item => item.name == employmentDetails.employerCategory?.value);
  const salaryDayNode = context.dropDownValues.SALARY_DAY.find(item => item.name == employmentDetails.salaryDay?.value);
  const salaryFrequencyNode = context.dropDownValues.SALARY_FREQUENCY.find(item => item.name == employmentDetails.salaryFrequency?.value);

  payload.employmentDetails = {
    employmentType: occuptionTypeNode?.value?.trim() || '',
    employeeCategory: employerCategoryNode?.value?.trim() || '',
    employeeMonthlyIncome:
      employmentDetails.grossMonthlySalary?.value?.trim() || '',
    employerIndustry: employmentIndustryNode?.value?.trim() || '',
    employerName: employmentDetails.employerName?.value?.trim() || '',
    employerPhoneNumber:
      employmentDetails.employerPhoneNumber?.value?.trim() || '',
    salaryDay: salaryDayNode?.value?.trim() || '',
    salaryFrequency: salaryFrequencyNode?.value?.trim() || ''
  };

  const bankDetails = context.vettingCreditDetails.bankDetails || {};

  const debitOrderNode = context.dropDownValues.DEBIT_ORDER_DATE.find(item => item.name == bankDetails.debitOrderDate?.value);
  const accountTypeNode = context.dropDownValues.BANK_ACCOUNT_TYPE.find(item => item.name == bankDetails.accountType?.value);

  payload.bankingDetails = {
    bankAccountName: bankDetails.accountHolderName?.value?.trim() || '',
    bankAccountNumber: bankDetails.accountNumber?.value?.trim() || '',
    bankAccountType: accountTypeNode?.value?.trim() || '',
    bankBranchCode: bankDetails.branchCode?.value?.trim() || '',
    bankName: bankDetails.bankName?.value?.trim() || '',
    directDebitCode: debitOrderNode?.value?.trim() || '',
    ...(!context.userExistingProperties['hideBankYears'] && { bankAccountYearsOpen: bankDetails.bankAccountYearsOpen?.value?.trim() || '' }),
    ...(!context.userExistingProperties['hideBankYears'] && { bankAccountMonthsOpen: bankDetails.bankAccountMonthsOpen?.value?.trim() || '' })
  };

  payload.debitOrderDay = bankDetails.debitOrderDate?.value?.trim() || '';

  payload.quoteNumber = '';
  payload.specialInstruction = '';

  payload.attachment = [];

  if (context.fileUploadId) {
    const idFileBuffer = await fileReader(context.fileUploadId);

    payload.attachment.push({
      documentType: context.employmentDetails.selectedIdTab === 'idNumber' ? 'IDcopy' : 'Passport',
      fileBuffer: idFileBuffer,
      fileExt: context.fileUploadId.type.split('/')[1],
      fileName: getFileNameWithoutExtension(context.fileUploadId.name).trim()
    });
  }

  if (context.fileUploadSaWorkPermit) {
    const statementFileBuffer = await fileReader(
      context.fileUploadSaWorkPermit
    );

    payload.attachment.push({
      documentType: 'WorkPermit',
      fileBuffer: statementFileBuffer,
      fileExt: context.fileUploadSaWorkPermit.type.split('/')[1],
      fileName: getFileNameWithoutExtension(
        context.fileUploadSaWorkPermit.name
      ).trim()
    });
  }

  if (context.additionalVas) {
    payload['additionalVas'] = context.additionalVas;
  } else {
    payload['additionalVas'] = [];
  }
  payload['dealType'] = context.selectedPackageType;
  payload['isExistingCustomer'] = context.isUserExisting;
  payload['vettingType'] = context.isUserExisting ? 'existingIndividual' : 'newIndividual';

  payload['debiCheckFlag'] = context.debiCheckSelected ? 'Y' : 'N';
  payload['superWifiDiscount'] = context?.additionalVas?.discount ? context?.additionalVas?.discount : '';
  payload.alternativeContactDetails = {
    alternativeContactFirstName: context.vettingCreditDetails?.contactDetails?.altContactPerson?.value?.trim(),
    alternativeContactMobilePhoneNumber: context.vettingCreditDetails?.contactDetails?.altCellPhoneNo?.value?.trim()
  };

  return config
    .submitOrder(payload, context.selectedPackage.offeringID)
    .then((res) => {
      return res.data ? Promise.resolve(res.data) : Promise.reject(res);
    })
    .catch((error) => Promise.reject(error));
}

async function fileReader(fileToRead) {
  return new Promise((resolve, reject) => {
    try {
      let reader = new FileReader();
      reader.onload = function (event) {
        let binary = '';
        let bytes = new Uint8Array(event.target.result);
        let len = bytes.byteLength;
        for (let i = 0; i < len; i++) {
          binary += String.fromCharCode(bytes[i]);
        }
        resolve(btoa(binary));
      };
      reader.readAsArrayBuffer(fileToRead);
    } catch (error) {
      reject(error);
    }
  });
}

export const submitCallmeBack = (callMeBackPayload, _context) => {
  return config
    .submitLead(callMeBackPayload)
    .then((res) => {
      if (res.data) {
        return Promise.resolve(res.data);
      } else {
        return Promise.reject(res);
      }
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};

export const getPortalOTP = (username, msisdn) => {

  msisdn = msisdn.replace(/\+/g, '');

  return config
    .getPortalOTP(username, msisdn)
    .then((res) => {
      if (res.data) {
        return Promise.resolve(res.data);
      } else {
        return Promise.reject(res);
      }
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};

export const validatePortalOTP = (username, otp) => {
  return config
    .validatePortalOTP(username, otp)
    .then((res) => {
      if (res.data) {
        return Promise.resolve(res.data);
      } else {
        return Promise.reject(res);
      }
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};

export function getCustomerOTP(username, context) {

  const payload = {
    agentName: username,
    phoneNumber: context.userDetails.contactNumber.replace(/\+/g, ''),
    email: context.userDetails.email,
    selectedOfferDetails: {
      customerFirstName: context.userDetails.firstName && context.userDetails.firstName.trim(),
      plan: context.selectedPackage.dataCap,
      speed: `${ parseInt(context.selectedPackage.download) }/${ parseInt(
        context.selectedPackage.upload
      ) } Mbps`,
      price: `R${ parseInt(context.selectedPackage.productPrice.value) } PM x ${ context.selectedContractTerm }`,
      inclusions: context.selectedPackage.inclusions,
      totalCost: `R${ parseInt(context.totalMonthlyCost) } PM x ${ context.selectedContractTerm }`,
      discount: context.selectedPackage.discountAmount && context.selectedPackage.discountTerm
        ? `R${ parseInt(context.selectedPackage.discountAmount) } PM x ${ context.selectedPackage.discountTerm }`
        : ''
    }
  };

  let id = context.employmentDetails.selectedIdTab === 'idNumber'
    ? context.employmentDetails.idNumber.trim()
    : context.employmentDetails.passportNumber.trim();

  return config
    .getCustomerOTP(id, payload)
    .then((res) => {
      return res.data ? Promise.resolve(res.data) : Promise.reject(res);
    })
    .catch((error) => Promise.reject(error));
}

export function getAddressDetails(address) {

  return config
    .getGeocodeFromAddress(address)
    .then((res) => {

      if (res.data) {
        return Promise.resolve(res?.data?.result);
      }
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}